<template>
  <Teleport to="body">
    <modal :showModal="visible" @closeModal="$emit('close')" maxWidth="600px">
      <template #content>
        <div class="w-full">
          <h2 class="modal-title">{{ `Exercises for ${patientName}` }}</h2>
          <div class="w-full">
            <alt-table :columns="COLUMNS">
              <template #t-row>
                <tr v-for="exercise in exercises" :key="exercise.id" class="hover:bg-gray-50">
                  <td class="px-4 py-2 text-sm">
                    {{ formatDate(exercise.date) }}
                  </td>

                  <td class="px-4 py-2 text-sm">
                    {{ extractExerciseName(exercise) }}
                  </td>

                  <td class="flex justify-center px-4 py-2 text-sm">
                    <button
                      class="w-full btn btn-primary btn-sm"
                      @click="$emit('download', exercise)"
                      :disabled="loadingId === exercise.videoReferencePath"
                    >
                      <span v-if="loadingId === exercise.videoReferencePath"> Downloading… </span>
                      <span v-else>Download</span>
                    </button>
                  </td>
                </tr>

                <tr v-if="!exercises.length" class="w-full">
                  <td colspan="3" class="px-4 py-6 text-gray-500 text-sm text-center">
                    No exercises found.
                  </td>
                </tr>
              </template>
            </alt-table>
          </div>
        </div>
      </template>
    </modal>
  </Teleport>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import altTable from '@/components/tables/altTable.vue';
import Modal from '@/components/Modal.vue';
const props = defineProps({
  visible: { type: Boolean, required: true },
  patientName: { type: String, default: '' },
  exercises: { type: Array, default: () => [] },
  loadingId: { type: [String, Boolean], default: null },
  hideClose: { type: Boolean, default: false },
});
defineEmits(['close', 'download']);

const COLUMNS = [{ header: 'Date' }, { header: 'Exercise Name' }, { header: 'Action' }];

const extractExerciseName = (exercise) => {
  const path = exercise.videoReferencePath;
  const match = path.match(/\/exercise\/([^/]+)/);
  return match ? match[1] : null;
};


function formatDate(date) {
  const d = new Date(date);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
}
</script>

<style scoped lang="scss">
.modal-title {
  margin: 0 0 1rem;
  font-size: 1.25rem;
  text-align: center;
}

.btn {
  padding: 0.25rem 0.5rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
}

.btn-secondary {
  background-color: #6c757d;
  color: #fff;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
